module.exports = __webpack_public_path__ + "media/images/homes/Cloud2x-a34e37a6dcd4d368b6f6a800580f084c.png";